module.exports = __webpack_public_path__ + "media/images/Checkbox_Icon-a362b075.svg";